// Customizable Area Start
import React from "react";
import CatalogueCarController, { Props } from "./CatalogueCardController.web";

import { Box, styled, Tooltip, withStyles } from "@material-ui/core";
import { colors } from "../../../blocks/utilities/src/Colors";
import {
  button_minus_dark,
  button_minus_light,
  button_plus_dark,
  sub_product_icon,
  NoImagePlaceholder,
} from "./assets";
import { CatalogueVariantsServices } from "../../../components/src/Interface";
import { renderBaseOnConditions } from "../../../blocks/utilities/src/CustomBlockHelpers";
// Customizable Area End

export default class CatalogueCard extends CatalogueCarController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start

  showCatalogueName = (fullName: string) => {
    if (fullName.length <= 25) {
      return <p className='catalogue-name'>{fullName}</p>;
    }
    return (
      <CatalogueTooltip
        title={<p className='catalogue-name'>{fullName}</p>}
        arrow
      >
        <span className='catalogue-name'>{fullName.slice(0, 25)}...</span>
      </CatalogueTooltip>
    );
  };
  // Customizable Area End

  render() {
    // Customizable Area Start
    const catalogueVariant = this.props.catalogue?.attributes;
    const goldenPointImage = this.props.catalogue;

    const catalogueVariantData =
      this.props.catalogue?.attributes?.catalogue_variants?.data[0]?.attributes;
    // Customizable Area End
    return (
      <CatalogueCardBox
        data-test-id='product-card-component'
        onClick={() => this.handleClickOnCard()}
        //  handleAddToCart={this.handleCreateQuickDropOrder}
      >
        <Box className='catalogue-image-wrapper'>
          {catalogueVariant?.icon ? (
            <img
              src={catalogueVariant.icon}
              className='catalogue-image'
              alt={catalogueVariant?.icon || "catalogue-image"}
            />
          ) : (
            <div className='catalogue-image-label'>
              <span
                className='catalogue-name'
                style={{ fontSize: "12px", whiteSpace: "wrap" }}
              >
                {catalogueVariant?.icon}
              </span>
            </div>
          )}
        </Box>
        <Box className='catalogue-title'>
          {/* {catalogueVariant?.icon ?  */}
          {this.showCatalogueName(catalogueVariant?.name)}
          {}
          {/* : <div style={{ height: "15px" }}></div>} */}

          {!this.state.isB2bActive && (
            <p className='catalogue-price'>
              SAR {catalogueVariant?.final_price || "N/A"}
            </p>
          )}
        </Box>
        {/* <Box className="mt-8">
  <p className="catalogue-title">{catalogueVariant?.name}</p>
</Box> */}

        <p className='catalogue-description'>
          Buy {catalogueVariant?.base_points} + {catalogueVariant?.bonus_points}{" "}
          bonus points
        </p>

        <p className='catalogue-description'>
          ({catalogueVariant?.golden_point_text_en})
        </p>

        <p className='catalogue-validity'>
          Valid till {catalogueVariant?.end_date_base}
        </p>

        <p className='catalogue-get-points'>
          Get {catalogueVariant?.total_points}
        </p>

        <p className='catalogue-free-wash'>
          Free Wash: {catalogueVariant?.free_wash_quentity}{" "}
          {catalogueVariant?.free_wash_description}
        </p>
        {/* {!this.state.activated && this.props.selectedProductQuantity < 1 && ( */}
          {this.props.selectedProductQuantity < 1 && (
          <button
            className='catalogue-price-button'
            // onClick={(e) => {
            //   e.stopPropagation();
            //   // this.setState({ activated: true });
            //   this.addQuaitityHandler();
            // }}

            onClick={(e) => {
              e.stopPropagation();

              if (
                !this.props.selectedCustomer &&
                !this.props.editSelectedCustomer
              ) {
                alert("Please select a customer first");
                return;
              }

              this.addQuaitityHandler();
            }}
          >
            SAR {catalogueVariant?.final_price}
          </button>
        )}

        {/* AFTER ACTIVATION → SHOW LEFT PRICE + RIGHT QTY */}
        {/* {this.state.activated && ( */}
          {this.props.selectedProductQuantity > 0 && (
          <>
            <p className='catalogue-price-left'>
              SAR {catalogueVariant?.final_price}
            </p>

            <Box className='catalogue-action-button'>
              <button className='catalogue-qty-button'>
                <img
                  src={button_plus_dark}
                  alt='plus'
                  onClick={(e) => {
                    e.stopPropagation();
                    if (
                      !this.props.selectedCustomer &&
                      !this.props.editSelectedCustomer
                    ) {
                      alert("Please select a customer first");
                      return;
                    }
                    this.addQuaitityHandler();
                  }}
                />
              </button>
              <span className='qty-value'>
                {this.props.selectedCustomer || this.props.editSelectedCustomer
                  ? this.props.selectedProductQuantity
                  : 0}
              </span>

              <button className='catalogue-qty-button'>
                <img
                  src={
                    this.props.selectedProductQuantity < 1
                      ? button_minus_light
                      : button_minus_dark
                  }
                  alt='minus'
                  onClick={(e) => {
                    e.stopPropagation();
                    if (
                      !this.props.selectedCustomer &&
                      !this.props.editSelectedCustomer
                    ) {
                      return;
                    }
                    this.removeQuaitityHandler();
                  }}
                />
              </button>
            </Box>
          </>
        )}
      </CatalogueCardBox>
    );
  }
}

// Customizable Area Start
// Customizable Area Start
const CatalogueCardBox = styled(Box)({
  flex: "0 0 calc(33.333% - 13.33px)",
  border: `1px solid ${colors().lightborder}`,
  padding: "10px",
  boxShadow: "0px 4px 12px rgba(0,0,0,0.05)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  minHeight: "280px",
  borderRadius: "12px",
  background: "#ffffff",
  margin: "6px",

  "& .catalogue-image-wrapper": {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    marginBottom: "10px",
  },
  "& .catalogue-image": {
    width: "70px",
    height: "70px",
    borderRadius: "10px",
    objectFit: "cover",
  },
  "& .catalogue-title": {
    fontSize: "15px",
    fontWeight: 700,
    textAlign: "center",
    marginBottom: "6px",
  },
  "& .catalogue-description": {
    fontSize: "12px",
    color: "#666",
    textAlign: "center",
    marginBottom: "4px",
    lineHeight: "1.4",
  },
  "& .catalogue-validity": {
    fontSize: "12px",
    fontWeight: 600,
    textAlign: "center",
    marginTop: "6px",
    marginBottom: "4px",
  },
  "& .catalogue-get-points": {
    fontSize: "13px",
    fontWeight: 700,
    textAlign: "center",
    marginBottom: "4px",
  },
  "& .catalogue-free-wash": {
    fontSize: "12px",
    textAlign: "center",
    marginBottom: "8px",
  },
  "& .catalogue-price-button": {
    background: "#1A73E8",
    color: "#fff",
    fontSize: "14px",
    fontWeight: 600,
    border: "none",
    padding: "8px 18px",
    borderRadius: "20px",
    cursor: "pointer",
    marginTop: "10px",
    transition: "0.3s",
  },
  "& .catalogue-price-button:hover": {
    opacity: 0.85,
  },

  "& .catalogue-price-left": {
    fontSize: "13px",
    fontWeight: 700,
    color: "#000",
    alignSelf: "flex-start",
    marginLeft: "4px",
    marginTop: "6px",
    marginBottom: "6px",
  },
  "& .catalogue-action-button": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginTop: "5px",
  },

  "& .catalogue-qty-button": {
    background: "transparent",
    border: "none",
    padding: "0",
    cursor: "pointer",
  },

  "& .catalogue-qty-button img": {
    width: "25px",
    height: "25px",
  },

  "& .qty-value": {
    fontSize: "15px",
    fontWeight: 600,
    width: "28px",
    textAlign: "center",
  },
});

export const CatalogueTooltip = withStyles({
  tooltip: {
    color: "black",
    fontSize: "12px",
    backgroundColor: "white",
    boxShadow:
      "rgba(0, 0, 0, 0.3) 0px 8px 32px 0px, rgba(0, 0, 0, 0.03) 0px 4px 8px 0px",
  },
  arrow: {
    color: "white",
    boxShadow:
      "rgba(0, 0, 0, 0.3) 0px 8px 32px 0px, rgba(0, 0, 0, 0.03) 0px 4px 8px 0px",
  },
})(Tooltip);
// Customizable Area End
